import { SET_WEBSITE_PROPERTY } from 'store/actions/website';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_WEBSITE_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  }
};
